// extracted by mini-css-extract-plugin
export default {"ag-styles":"L_g","detailCellRenderer":"L_dp"};